import { Link } from 'react-router-dom';

export default function Logo({ size = 'default', linkTo = '/', className = '' }) {
  const sizes = {
    small: 'h-8',
    default: 'h-10',
    large: 'h-12',
  };
  
  const s = sizes[size] || sizes.default;
  
  const content = (
    <img 
      src="/atlas-logo.png" 
      alt="Atlas" 
      className={`${s} w-auto object-contain ${className}`}
    />
  );
  
  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center hover:opacity-80 transition-opacity">
        {content}
      </Link>
    );
  }
  
  return content;
}
